import { render, staticRenderFns } from "./MoreView.vue?vue&type=template&id=d617d668&scoped=true"
import script from "./MoreView.vue?vue&type=script&lang=js"
export * from "./MoreView.vue?vue&type=script&lang=js"
import style0 from "./MoreView.vue?vue&type=style&index=0&id=d617d668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d617d668",
  null
  
)

export default component.exports